import {
    IMeasureFilter,
    newAbsoluteDateFilter,
    newAttribute,
    newNegativeAttributeFilter,
    newPositiveAttributeFilter,
    newRelativeDateFilter,
} from '@gooddata/sdk-model';
import { DateInstances } from '@mews-framework/good-data/generated/internal';
import { notNil } from '@mews/fp';
import { DatePeriod } from '../../common/components/ReportingDateRangePicker';
import { DateRange, Filter, FilterFieldsValues } from '../../common/types';
import { RelativePeriods } from './constants';
import { MeasureFilter, MeasureFilterType } from './types';

interface CreateGoodDataFiltersProps {
    dateRange?: DateRange;
    dateType?: DateInstances;
    filters?: Filter[];
    filterValues?: FilterFieldsValues;
}

export const createReportGDFilters = ({ dateRange, dateType, filters, filterValues }: CreateGoodDataFiltersProps) => {
    const goodDataFilters = filters
        ? filters
              .map(({ filterId, goodData }) => {
                  const value = filterValues ? (filterValues[filterId] as string[]) : null;
                  if (!goodData || !value || !value.length) return null;
                  return newPositiveAttributeFilter(newAttribute(goodData.entity), value);
              })
              .filter(notNil)
        : [];

    const dateFilter =
        dateRange && dateType
            ? [
                  dateRange.datePeriod === DatePeriod.Custom
                      ? newAbsoluteDateFilter(dateType, dateRange.startDate, dateRange.endDate)
                      : newRelativeDateFilter(dateType, ...RelativePeriods[dateRange.datePeriod]),
              ]
            : [];
    return [...dateFilter, ...goodDataFilters];
};

export const createMeasureFilters = (filters: MeasureFilter[]): IMeasureFilter[] =>
    filters
        .map((measureFilter) => {
            switch (measureFilter.type) {
                case MeasureFilterType.PositiveAttribute:
                    return newPositiveAttributeFilter(newAttribute(measureFilter.id), measureFilter.value);
                case MeasureFilterType.NegativeAttribute:
                    return newNegativeAttributeFilter(newAttribute(measureFilter.id), measureFilter.value);
                case MeasureFilterType.AbsoluteDate:
                    return newAbsoluteDateFilter(measureFilter.id, measureFilter.startDate, measureFilter.endDate);
                case MeasureFilterType.RelativeDate:
                    return newRelativeDateFilter(measureFilter.id, ...RelativePeriods[measureFilter.datePeriod]);
                default:
                    throw new Error(`Unknown measure filter type: '${(measureFilter as { type: string }).type}'`);
            }
        })
        .filter(notNil);
